module.exports = __webpack_public_path__ + "media/29.02dd9cf1.wav";